// extracted by mini-css-extract-plugin
export var address = "footer-module--address--6P-hK";
export var callNow = "footer-module--callNow--BcbMz";
export var copyright = "footer-module--copyright---uNW9";
export var footerCallout = "footer-module--footerCallout--zMMFb";
export var links = "footer-module--links--2yaKi";
export var root = "footer-module--root--XWrxy";
export var row = "footer-module--row--Kagf6";
export var textSmall = "footer-module--textSmall--0Tkcx";
export var veryBottom = "footer-module--veryBottom--2+P7q";